import gql from "graphql-tag";

const UserFragment = gql`
  fragment UserFragment on users {
      user_email
      user_phone
      user_first_name
      user_id
      user_last_name
      user_cognito_username
      user_status
      user_preferred_name
  }
`;

export const GET_LC_USERS = gql`
    query getLCUsers {
        users(
            where: {
                user_type: { _eq: "lead_coach" }
            }
        ) {
            ...UserFragment
            lc_profiles {
                id
                available
                college_info
            }
        }
        settings: settings_by_pk(key: "DEFAULT_LC_ID") {
            key
            value
        }
    }
    ${UserFragment}
`;

export const GET_HC_USER = gql`
    query getHCUsers {
        users(
            where: {
                user_type: { _eq: "head_coach" }
            }
        ) {
            ...UserFragment
            hc_profiles {
                id
                available
            }
        }
        settings: settings_by_pk(key: "DEFAULT_HC_ID") {
            key
            value
        }
    }
    ${UserFragment}
`;

export const GET_FA_USERS = gql`
    query getHCUsers {
        users(
            where: {
                user_type: { _eq: "fa_coach" }
            }
        ) {
            ...UserFragment
            fc_profiles {
                id
                available
            }
        }
        settings: settings_by_pk(key: "DEFAULT_FA_ID") {
            key
            value
        }
    }
    ${UserFragment}
`;